const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
const PHONE_RE = /^(\+34)?[6789]\d{8}$/;
const URL_RE = /^(https?:\/\/)?([A-Za-z0-9-]+\.)+[A-Za-z]{2,}(\/\S*)?$/;
const NIF_LETTERS = "TRWAGMYFPDXBNJZSQVHLCKE";
const CIF_CONTROL_LETTERS = "JABCDEFGHI";

export function validTaxId(value) {
  const v = String(value || "").replace(/[\s\-.]/g, "").toUpperCase();
  if (!v) return "El CIF/NIF es obligatorio";
  if (/^\d{8}[A-Z]$/.test(v)) {
    return NIF_LETTERS[parseInt(v.slice(0, 8), 10) % 23] === v[8]
      ? null
      : "Introduce un NIF válido (letra de control incorrecta)";
  }
  let m = v.match(/^([XYZ])(\d{7})([A-Z])$/);
  if (m) {
    const num = parseInt({ X: "0", Y: "1", Z: "2" }[m[1]] + m[2], 10);
    return NIF_LETTERS[num % 23] === m[3]
      ? null
      : "Introduce un NIE válido (letra de control incorrecta)";
  }
  m = v.match(/^([ABCDEFGHJNPQRSUVW])(\d{7})([0-9A-J])$/);
  if (m) {
    const d = m[2];
    const even = parseInt(d[1]) + parseInt(d[3]) + parseInt(d[5]);
    const odd = [0, 2, 4, 6].reduce((acc, i) => {
      const n = parseInt(d[i]) * 2;
      return acc + Math.floor(n / 10) + (n % 10);
    }, 0);
    const control = (10 - ((even + odd) % 10)) % 10;
    const org = m[1];
    const given = m[3];
    const ok = "PQRSWN".includes(org)
      ? given === CIF_CONTROL_LETTERS[control]
      : "ABEH".includes(org)
        ? given === String(control)
        : given === String(control) || given === CIF_CONTROL_LETTERS[control];
    return ok ? null : "Introduce un CIF válido (dígito de control incorrecto)";
  }
  return "Introduce un CIF/NIF/NIE español válido";
}

export function validEmail(value) {
  const v = String(value || "").trim();
  if (!v) return "El email es obligatorio";
  return EMAIL_RE.test(v) ? null : "Introduce un email profesional válido";
}

export function validUrl(value) {
  const v = String(value || "").trim();
  if (!v) return null;
  return URL_RE.test(v) ? null : "Introduce una URL válida (por ejemplo, https://tuempresa.com)";
}

export function validPhone(value) {
  const v = String(value || "").replace(/[\s\-.]/g, "");
  if (!v) return null;
  return PHONE_RE.test(v) ? null : "Introduce un teléfono español válido";
}

export function validEmployees(value) {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number(value);
  if (!Number.isFinite(n) || n < 0) return "Introduce un número de empleados válido";
  return null;
}

export function required(value, msg = "Campo obligatorio") {
  return String(value || "").trim() ? null : msg;
}

const STEP_FIELDS = {
  0: ["legal_name", "tax_id", "website", "industry", "employee_count"],
  1: ["first_name", "last_name", "position", "email", "phone"],
  2: ["terms_accepted"],
};

export function validateStep(step, data) {
  const errors = {};
  const check = (field, err) => {
    if (err) errors[field] = err;
  };
  if (step === 0) {
    check("legal_name", required(data.legal_name, "La razón social es obligatoria"));
    check("tax_id", validTaxId(data.tax_id));
    check("website", validUrl(data.website));
    check("industry", required(data.industry, "Indica el sector o actividad"));
    check("employee_count", validEmployees(data.employee_count));
  }
  if (step === 1) {
    check("first_name", required(data.first_name, "El nombre es obligatorio"));
    check("last_name", required(data.last_name, "Los apellidos son obligatorios"));
    check("position", required(data.position, "Indica tu cargo en la empresa"));
    check("email", validEmail(data.email));
    check("phone", validPhone(data.phone));
  }
  if (step === 2) {
    check("terms_accepted", data.terms_accepted ? null : "Debes aceptar las Condiciones del Servicio");
  }
  return errors;
}

export function stepOfField(field) {
  for (const [step, fields] of Object.entries(STEP_FIELDS)) {
    if (fields.includes(field)) return Number(step);
  }
  return 0;
}
